import { MessageCircle, Zap } from "lucide-react";
import iconShopee from "@/assets/icon-shopee.jpg";
import iconTiktok from "@/assets/icon-tiktok-round.png";

const channels = [
  { icon: iconShopee, label: "Shopee Live", size: 16 },
  { icon: iconTiktok, label: "TikTok Chat", size: 16 },
];

export function ChatMockup() {
  return (
    <div className="text-[11px]">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-border bg-card/80">
        <div className="flex items-center gap-2">
          <MessageCircle className="h-3.5 w-3.5 text-muted-foreground" />
          <span className="text-[12px] font-medium text-foreground">AI Chat</span>
          <span className="text-[10px] text-foreground/60 bg-muted px-1.5 py-0.5 rounded">{channels.length} channels</span>
        </div>
        <div className="flex items-center gap-1">
          <Zap className="h-3 w-3 text-success" />
          <span className="text-[10px] text-success">100% response rate</span>
        </div>
      </div>

      <div className="divide-y divide-border">
        {channels.map((ch) => (
          <div key={ch.label} className="flex items-center justify-between px-4 py-2 hover:bg-muted/20 transition-colors">
            <div className="flex items-center gap-2.5">
              <div className="h-5 w-5 flex items-center justify-center shrink-0">
                <img
                  src={ch.icon}
                  alt={ch.label}
                  className="rounded-sm object-contain"
                  style={{ width: ch.size, height: ch.size }}
                />
              </div>
              <span className="font-medium text-foreground">{ch.label}</span>
            </div>
            <span className="text-[10px] text-success bg-success/10 px-1.5 py-0.5 rounded font-medium">100%</span>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between px-4 py-2.5 border-t border-border bg-muted/20">
        <span className="text-muted-foreground">Response rate: <span className="text-success font-medium">100%</span></span>
        <span className="text-muted-foreground">Avg. response: 1.2s</span>
      </div>
    </div>
  );
}
